import { createStore } from 'vuex'
import consts from "@/consts";

import app from './modules/app'
import map from './modules/map'
import security from './modules/security'
import access_rights from './modules/access-rights'

import units_helper from './modules/units-helper'
import users from './modules/users'
import usersObjectsTemplates from './modules/users-objects-templates'
import usersProfiles from "@/store/modules/users-profiles";
import users_favorites from './modules/user-favorites'
import user_ext_services from './modules/user-ext-services'
import user_sms_gateway from './modules/user-sms-gateway'
import drivers from './modules/drivers'
import drivers_groups from './modules/drivers-groups'
import appointments from './modules/appointments'
import customize from './modules/customize'
import units from './modules/units'
import units_groups from './modules/units-groups';
import units_lmsgs from './modules/units-lmsgs'
import units_msgs from './modules/units-msgs'
import units_msgs_groupby from './modules/units-msgs-groupby'
import video_statuses from './modules/video_statuses'
import geotab from './modules/geotab'
import unit_locator from './modules/unit-locator'
import trandataDms from "./modules/trandata-dms";

import shipments from './modules/shipments'
import shipments_packages from './modules/shipments-packages'
import shipments_alerts from './modules/shipments-alerts'
import shipments_tracks from './modules/shipments-tracks'
import shipments_templates from './modules/shipments-templates'
import shipments_notifications_templates from './modules/shipments-notifications-templates'
import shipments_devices from './modules/shipments-devices'
import tive_carriers from './modules/tive-carriers'
import shipments_alerts_presets from './modules/shipments-alerts-presets'
import shipments_address_templates from './modules/shipments-address-templates'
import shipments_types from './modules/shipments_types'
import shipments_locator from './modules/shipments-locator'
import shipments_statistics from './modules/shipments-statistics'

import greensees_devices from './modules/greensee/devices'
import greensees_trips from './modules/greensee/trips'
import greensees_stops from './modules/greensee/stops'
import greensees_events from './modules/greensee/events'

import geoitems from './modules/geoitems'
import geozones from './modules/geozones'
import geozones_groups from './modules/geozones-groups';
import geopoints from './modules/geopoints'
import geopoints_groups from './modules/geopoints-groups';
import notifications from './modules/notifications'

import grafana from './modules/grafana/grafana'
import xroutes from './modules/xroutes'
import xroutes_users from './modules/xroutes_users'
import xroutes_waypoints from './modules/xroutes_waypoints'
import xroutes_calculated from './modules/xroutes_calculated'

import orchestrator_users from './modules/orchestrator/orchestrator-users'

import services from "./modules/services";
// import notifications_types from './modules/notifications-types'

import notifications_history from './modules/notifications_history'

import units_hwtypes from "./modules/units_hwtypes";

import trips from './modules/trips'
import parkings from './modules/parkings'
import idlings from './modules/idlings'
import stops from './modules/stops'
import events from './modules/events'
import commands from './modules/commands'
import sensors from './modules/sensors'
import screenshots from './modules/screenshots'
import video_events from './modules/video_events'
import video_requests from './modules/video_requests'
import video_records from './modules/video_records'
import tracks from './modules/tracks'
import accidents from './modules/accidents'

import maintenance from "./modules/maintenance"
import maintenanceVendors from "./modules/maintenance-vendors";
import maintenanceContacts from "./modules/maintenance-contacts";
import maintenanceContactGroups from "./modules/maintenance-contact-groups";
import maintenanceParts from "./modules/maintenance-parts";
import maintenanceServiceTasks from "./modules/maintenance-service-tasks";
import maintenanceIssues from "./modules/maintenance-issues";
import maintenanceWorkOrders from "./modules/maintenance-work-orders";
import maintenanceInspections from "./modules/maintenance-inspections";
import maintenanceHistory from "./modules/maintenance-history";
import maintenanceNotifications from "./modules/maintenance-notifications";
import maintenanceExpenses from "./modules/maintenance-expenses";

import insuranceReports from "./modules/insurance-reports";

import weather from "./modules/weather";

import template_reports from "./modules/template-reports";
import reports_scheduler from "./modules/reports-scheduler";
import reports_templates from "./modules/reports_templates";
import reports from "./modules/reports";
import statistics from "./modules/statistics";

const getFnName = function(name, args) {
    name = name || ''
    if(!args) return name;

    if(args.id){
        name += '#id:'+args?.id
    } else
    if(args.groupId){
        name += '#groupId:'+args?.groupId
    } else
    if(args.unitId){
        name += '#unitId:'+args?.unitId
    }
    else
    if(args['filter[special]']){
        name += '#special:'+args['filter[special]']
    }
    return name
}

const debugFetchs = [
    // 'fetchCommandsChanged',
    // 'fetchEventsChanged',
    // 'fetchVideoEventsChanged',

    // 'fetchStopsChanged',
    // 'fetchParkingsChanged',
    // 'fetchIdlingsChanged',
    // 'fetchTripsChanged',
    //'fetchUnitsMsgsChanged',
    // 'fetchUnitsLmsgsChanged',
    // 'fetchUnitLmsg',
];

export default createStore({
    state: {
        appObjectsFullLoad: false,
        fetchByPage: [],
        last_call: {},
        theme: consts.themes.white,
    },
    getters: {
        isAppObjectsFullLoad(state){
            return state.appObjectsFullLoad
        },
        getLastCall(state){
            return state.last_call
        },
        getFetchByPage(state){
            return state.fetchByPage
        },
        getTheme(state) {
            let theme = state.theme
            if(!Object.values(consts.themes).includes(theme)) {
                console.error('themes:', consts?.themes, 'theme:', theme)
                theme = consts.themes.white
            }
            return theme
        }
    },
    mutations: {
        setTheme(state, theme) {
            state.theme = theme
            localStorage.setItem(process.env.VUE_APP_PRODUCT +'.theme', theme); //toDo fix ???
        },
        setAppObjectsFullLoad(state, FullLoad){
            state.appObjectsFullLoad = state.appObjectsFullLoad || FullLoad
        },
        clearAppObjectsFullLoad(state){
            state.appObjectsFullLoad = false
        },
        setLastCall(state, args){
            if (debugFetchs.includes(args?.name)) console.log('setLastCall', args)
            let name = getFnName(args?.name, args?.args)
            let time = state.last_call[name] || 0
            if(args?.time > 0){
                if(time > Date.now()/1000 && !args?.args?.page && consts.app.$isDevelopment) {
                    //console.error('setLastCall (time)', name, args?.name, args?.args)
                }
                time = args.time + consts.api.defaults.timeout
            } else
            if(args?.inprogress === false){
                if(time > Date.now()/1000) {
                    time -= consts.api.defaults.timeout
                } else if (!time && consts.app.$isDevelopment) {
                    //console.error('setLastCall (!inprogress)', name, args?.name, args?.args)
                }
            }
            state.last_call[name] = time
        },
        clearLastCall(state){
            state.last_call = {}
        },
        addFetchFnsByPage(state, fetchFns){
            if(!fetchFns) {
                state.fetchByPage = [];
                return;
            }
            if(!Array.isArray(fetchFns) ) {
                console.error('addFetchFnsByPage', fetchFns)
                return;
            }
            fetchFns.forEach(f => {
                if (debugFetchs.includes(f?.name)) console.log('addFetchFnsByPage', f)
                let fetchFnByPage = state.fetchByPage.find(ff => ff.name == f.name && ff.page == f.page)
                if (fetchFnByPage) {
                    fetchFnByPage.params = f.params
                    fetchFnByPage.eachT = f.eachT
                } else {
                    state.fetchByPage.push(f)
                }
            })
        }
    },
    actions: {
        // setTheme({getters, commit}, theme) {
        //     let storageKey = getters.getUserStorageKey + '.theme'
        //     console.log(storageKey, theme)
        //     localStorage.setItem(storageKey, theme);
        //     commit('setTheme', theme)
        // },
        setLastCall({commit}, args){
            commit('setLastCall', args)
        },
        addFetchFnsByPage({commit}, args){
            commit('addFetchFnsByPage', args)
        },
        fetchAppProps({ getters, dispatch }) {
            if(!getters.getApiToken) {
                // return
            }
            let dispatches = consts.fetchAppProps.dispatches || []
            // dispatches.sort(function (a, b) {
            //     return (b.priority || 0) - (a.priority || 0);
            // })
            // console.log('fetchAppProps', dispatches)
            dispatches.forEach(dsp => {
                dispatch(dsp.name, {...dsp.params})
                    .catch((error) => {
                        if (consts.app.$isDevelopment) console.error(dsp.name, dsp.params, error);
                    })
            })
        },
        fetchByTimer({ getters, dispatch }, params) {
            // console.log('fetchByTimer', params)
            if(!getters.isAppObjectsFullLoad) {
                return
            }
            let time = params.time
            let page = params.page
            //by page
            let dispatches = (getters.getFetchByPage || [])
                .filter(dsp => dsp.page == page && dsp.eachT > 0)
            // if (consts.app.$isDevelopment) console.log('fetchByPage', time, page, dispatches)
            dispatches.forEach(dsp => {
                let name = getFnName(dsp.name, dsp.params)
                let lastCall = getters.getLastCall[name] || 0
                if (debugFetchs.includes(dsp.name)) console.log('fetchByPage', dsp, time-(lastCall+dsp.eachT))
                if(time>=lastCall+dsp.eachT) {
                    dispatch(dsp.name, {...dsp.params})
                        .catch((error) => {
                            if (consts.app.$isDevelopment) console.error(dsp.name, dsp.params, error);
                        })
                    //dispatch('setLastCall', {...dsp, time})
                }
            })
            //by time
            let sys_dispatches = consts.fetchByTimer.sys_dispatches || []
            dispatches = consts.fetchByTimer.dispatches || []
            dispatches = [...sys_dispatches, ...dispatches]
            // if (consts.app.$isDevelopment) console.log('fetchByTime', time, dispatches)
            dispatches.forEach(dsp => {
                let name = getFnName(dsp.name, dsp.params)
                let lastCall = getters.getLastCall[name] || 0
                if (debugFetchs.includes(dsp.name)) console.log('fetchByTimer', dsp, time-(lastCall+dsp.eachT))
                if(time>=lastCall+dsp.eachT) {
                    dispatch(dsp.name, {...dsp.params})
                        .catch((error) => {
                            if (consts.app.$isDevelopment) console.error(dsp.name, dsp.params, error);
                        })
                    //dispatch('setLastCall', {...dsp, time})
                }
            })
        },
        fetchAppObjects({dispatch, commit, getters}, dispatches) {
            if (!getters.getApiToken) {
                return false
            }
            if (typeof dispatches === 'object' && !Array.isArray(dispatches)) dispatches = Object.values(dispatches)
            if (typeof dispatches !== 'object' && !Array.isArray(dispatches)) {
                console.error('fetchAppObjects', 'dispatches is not array')
                return false
            }
            dispatch('setLastCall', {name: 'fetchAppObjects', time: Date.now() / 1000})
            dispatches.forEach(dsp => {
                if (!dsp?.name) return
                let name = (dsp?.name || '').replace('All', '') //.replace('Changed', '')
                dispatch('setLastCall', {name: name+'All', time: Date.now() / 1000})
                dispatch('setLastCall', {name: name+'Changed', time: Date.now() / 1000})
            })

            // let lsUnits = JSON.parse(localStorage.getItem(getters.getUserStorageKey + '.units'))
            // // console.log('fetchAppObjects lsUnits', lsUnits)
            // new Promise((resolve, reject) => {
            //     if (!lsUnits.length) {
            //         resolve({})
            //         return
            //     }
            //     this.$api.init.getObjects({objs: 'unitsIds'})
            //         .then((response) => {
            //             if (response.status < 400 && !response.data?.error) {
            //                 resolve(response.data)
            //             } else {
            //                 reject(response.data)
            //             }
            //         })
            //         .catch((error) => {
            //             reject(error)
            //             console.error(error);
            //         })
            // })
            //     .then((data) => {
            //         console.log('fetchAppObjects unitsIds', data.unitsIds)
            //         let unitsIds = data.unitsIds || []
            //         if (lsUnits.length && unitsIds.length) {
            //             let units = lsUnits.filter(u => unitsIds.includes(u.id))
            //             commit('setUnits', units)
            //         }
            //         return

            const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
            let fetches = [

                //     new Promise((resolve, reject) => {
                //         this.$api.init.getUnits()
                //             .then((response) => {
                //                 if (response.status < 400 && !response.data?.error) {
                //                     resolve(response.data)
                //                 } else {
                //                     reject(response.data)
                //                 }
                //             })
                //             .catch((error) => {
                //                 reject(error)
                //                 console.error(error);
                //             })
                //     }),
                //     new Promise((resolve, reject) => {
                //         this.$api.init.getUnitsLmsgs()
                //             .then((response) => {
                //                 if (response.status < 400 && !response.data?.error) {
                //                     resolve(response.data)
                //                 } else {
                //                     reject(response.data)
                //                 }
                //             })
                //             .catch((error) => {
                //                 reject(error)
                //                 console.error(error);
                //             })
                //     }),

                    new Promise((resolve, reject) => {
                        this.$api.init.getObjects({objs:'units,lmsgs', ...with_removed})
                            .then((response) => {
                                if (response.status < 400 && !response.data?.error) {
                                    let units = response.data?.units || []
                                    let lmsgs = response.data?.lmsgs || []
                                    commit('updateUnits', units)
                                    commit('setUnitsLiteLoad', true)

                                    commit('updateUnitsLmsgs', lmsgs)
                                    commit('setUnitsLmsgsLiteLoad', true)

                                    resolve(true)
                                } else {
                                    reject(response.data)
                                }
                            })
                            .catch((error) => {
                                reject(error)
                                console.error(error);
                                setTimeout(() => {
                                    dispatch('fetchUnitsAllLite', {})
                                    dispatch('fetchUnitsLmsgsAllLite', {})
                                }, 60*1000)
                            })
                    }),
                new Promise((resolve, reject) => {
                    this.$api.init.getObjects({objs:'units-groups', ...with_removed})
                        .then((response) => {
                            if (response.status < 400 && !response.data?.error) {
                                let groups = response.data['units-groups'] || []
                                commit('updateUnitsGroups', groups)
                                commit('setUnitsGroupsLiteLoad', true)

                                resolve(true)
                            } else {
                                reject(response.data)
                            }
                        })
                        .catch((error) => {
                            reject(error)
                            console.error(error);
                            setTimeout(() => {
                                dispatch('fetchUnitsGroupsAllLite', {})
                            }, 60*1000)
                        })
                }),
            ]

            dispatches
                .filter(dsp => !(['fetchUnitsAll', 'fetchUnitsLmsgsAll', 'fetchUnitsGroupsAll']).includes(dsp.name) )
                .forEach(dsp => {
                    fetches.push(dispatch(dsp.name, {...dsp.params}))
                })

            Promise.all(fetches)
                .then(() => {
                    let fetch = dispatches.map(dsp => {
                        dispatch(dsp.name+'Pages', {...dsp.params})// *AllPages
                    })
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setAppObjectsFullLoad', true)
                        });
                })
                .catch((error) => {
                    // setTimeout(() => {
                    //     dispatch('fetchUnitsInit', {})
                    // }, 60*1000)
                    console.error(error);
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchAppObjects', inprogress: false})
                });
        },
        reloadAppProps({ dispatch, commit }) {
            // if(!getters.getApiToken) {
            //     // return
            // }

            let commits = consts.reloadAppProps.commits || []
            // commits.sort(function (a, b) {
            //     return (b.priority || 0) - (a.priority || 0);
            // })
            // console.log('reloadAppProps', commits)
            commits.forEach(cmt => {
                commit(cmt.name, {...cmt.params})
            })

            let dispatches = consts.reloadAppProps.dispatches || []
            // dispatches.sort(function (a, b) {
            //     return (b.priority || 0) - (a.priority || 0);
            // })
            // console.log('reloadAppProps', dispatches)
            dispatches.forEach(dsp => {
                dispatch(dsp.name, {...dsp.params})
                    .catch((error) => {
                        if (consts.app.$isDevelopment) console.error(dsp.name, dsp.params, error);
                    })
            })
        },
        clearAllData({commit}) {
            commit('clearUnits')
            commit('clearUnitsLmsgs')
            commit('clearUnitsGroups')
            commit('clearUnitsHwTypes')

            commit('clearUsers')
            commit('clearUsersProfiles')
            commit('clearCustomizes')
            commit('clearUsersObjectsTemplates')
            commit('clearUserFavorites')

            commit('clearCommands')
            commit('clearTrandataDms')
            commit('clearSensors')

            commit('clearGeopoints')
            commit('clearGeopointsGroups')
            commit('clearGeozones')
            commit('clearGeozonesGroups')

            commit('clearDrivers')
            commit('clearDriversGroups')

            commit('clearNotifications')
            commit('clearNotificationsTypes')

            commit('clearTrips')
            commit('clearParkings')
            commit('clearTracks')
            commit('clearIdlings')
            commit('clearUnitsMsgs')
            commit('clearUnitsMsgsGroupBy')

            commit('clearStops')
            commit('clearNotificationsEvents')
            commit('clearEvents')
            commit('clearAccidents')
            commit('clearAppointments')
            commit('clearScreenshots')
            commit('clearVideoStatuses')
            commit('clearVideoEvents')
            commit('clearVideoRequests')
            commit('clearVideoRecords')
            commit('clearGeotabCredentials')

            commit('clearGreenseesDevices')
            commit('clearGreenseeEvents')
            commit('clearGreenseeStops')
            commit('clearGreenseeTrips')

            commit('clearOrchestratorUsers')
            commit('clearUserSmsGateways')

            commit('clearXRoutes')
            commit('clearXRoutesCalculated')
            commit('clearXRoutesUsers')
            commit('clearXRoutesWaypoints')

            commit('clearShipments')
            commit('clearShipmentTypes')
            commit('clearShipmentsAddressTemplates')
            commit('clearShipmentsAlertsPresets')
            commit('clearShipmentsAlerts')
            commit('clearShipmentsDevices')
            commit('clearShipmentsNotificationTemplates')
            commit('clearShipmentsTemplates')
            commit('clearShipmentsPackages')
            commit('clearShipmentsTracks')

            commit('clearMaintenance')
            commit('clearMaintenanceContactGroups')
            commit('clearMaintenanceContacts')
            commit('clearMaintenanceExpenses')
            commit('clearMaintenanceHistorys')
            commit('clearMaintenanceInspections')
            commit('clearMaintenanceIssues')
            commit('clearMaintenanceNotifications')
            commit('clearMaintenanceParts')
            commit('clearMaintenanceServiceTasks')
            commit('clearMaintenanceVendors')
            commit('clearMaintenanceWorkOrders')

            commit('clearInsuranceReports')
            commit('clearReportsSchedulers')
            commit('clearTemplateReports')
            commit('clearTiveCarriers')
            commit('clearServices')

            commit('setAllGeoitemsShowOnMap', [])
            commit('setAllUnitsShowOnMap', [])

            commit('addFetchFnsByPage', null)
            commit('clearLastCall')
            commit('clearAppObjectsFullLoad')
            //give time to redraw the page
            setTimeout(() => commit('clearAppUser'), 300)
        },
    },
    modules: {
        app,
        map,
        security,
        access_rights,
        units_hwtypes,

        units_helper,
        units,
        drivers,
        drivers_groups,
        appointments,
        units_lmsgs,
        units_msgs,
        units_msgs_groupby,
        video_statuses,
        geotab,
        units_groups,
        trandataDms,

        users,
        usersObjectsTemplates,
        usersProfiles,
        users_favorites,
        user_ext_services,
        user_sms_gateway,
        customize,

        geoitems,
        geozones,
        geozones_groups,
        geopoints,
        geopoints_groups,

        trips,
        parkings,
        idlings,
        tracks,

        accidents,
        stops,
        notifications_history,
        events,
        commands,
        sensors,
        screenshots,
        video_events,
        video_requests,
        video_records,

        template_reports,
        reports_scheduler,
        reports_templates,
        reports,

        // notifications_types,
        notifications,

        shipments,
        shipments_packages,
        shipments_alerts,
        shipments_tracks,
        shipments_templates,
        shipments_notifications_templates,
        shipments_devices,
        shipments_alerts_presets,
        shipments_address_templates,
        shipments_types,
        shipments_locator,
        shipments_statistics,
        tive_carriers,

        greensees_devices,
        greensees_trips,
        greensees_stops,
        greensees_events,

        maintenance,//->maintenanceServices
        maintenanceVendors,
        maintenanceContacts,
        maintenanceContactGroups,
        maintenanceParts,
        maintenanceServiceTasks,
        maintenanceIssues,
        maintenanceWorkOrders,
        maintenanceInspections,
        maintenanceHistory,
        maintenanceNotifications,
        maintenanceExpenses,

        insuranceReports,

        xroutes,
        xroutes_users,
        xroutes_waypoints,
        xroutes_calculated,
        //orchestrator
        orchestrator_users,

        statistics,
        weather,

        unit_locator,

        services,
        grafana,
    }
})
